module.exports = __webpack_public_path__ + "static/media/BrutalType-Regular.c36d188d.woff";